import React from 'react';
import { CheckIcon, TargetIcon } from 'lucide-react';
import { SectionLabel } from '../SectionLabel';
import { CtaButton } from '../CtaButton';
import { volumes } from '../../data/content';
export function Volumes() {
  return <section className="w-full bg-white px-4 py-12 sm:px-6 sm:py-20" data-id="element-348" data-mp="2wzypqb1d4whc">
      <div className="mx-auto max-w-4xl" data-id="element-349" data-mp="2t07x01sa06a6">
        <div className="text-center" data-id="element-350" data-mp="2szewhijwud0h">
          <SectionLabel data-id="element-351" data-mp="2o0bpvtoa7yqe">Il contenuto</SectionLabel>
          <h2 className="mt-3 font-display text-[26px] font-extrabold leading-[1.15] text-navy-deep sm:text-4xl md:text-[42px]" data-id="element-352" data-mp="2o26a15rqbmtf">
            Cosa contiene Percorso Malattia Renale™?
          </h2>
          <p className="mx-auto mt-4 max-w-xl text-[15px] leading-relaxed text-navy/75 sm:text-lg" data-id="element-353" data-mp="2ebbns1ehgn7z">
            Un sistema completo che ti accompagna dalla prima creatinina alterata fino
            al monitoraggio del paziente con malattia renale.
          </p>
        </div>

        <div className="mt-8 flex flex-col gap-5 sm:mt-12 sm:gap-7" data-id="element-354" data-mp="20c28d3y3px52">
          {volumes.map(volume => <article key={volume.id} className="overflow-hidden rounded-3xl border border-navy-deep/10 bg-cream" data-id="element-355" data-mp="334ui3wxvyhur">
              <div className="flex items-center gap-3 px-5 py-3.5 sm:px-7" style={{
            backgroundColor: volume.accent
          }} data-id="element-356" data-mp="2u4y2slxdyvcd">
                <span className="text-[10.5px] font-extrabold uppercase tracking-[0.2em] text-white/80" data-id="element-357" data-mp="2y6synawjsgir">
                  {volume.label}
                </span>
              </div>

              <div className="px-5 py-6 sm:px-7 sm:py-8" data-id="element-358" data-mp="3qtxc849pi365">
                <h3 className="font-display text-[22px] font-extrabold leading-tight text-navy-deep sm:text-[28px]" data-id="element-359" data-mp="3cvpevv8rczug">
                  {volume.title}
                </h3>
                <p className="mt-2.5 text-[15px] font-semibold leading-relaxed text-kidney-dark sm:text-base" data-id="element-360" data-mp="3hwmuq16aphss">
                  {volume.promise}
                </p>
                <p className="mt-3 text-[14px] leading-relaxed text-navy/75 sm:text-[15px]" data-id="element-361" data-mp="26g4zg4efpl7q">
                  {volume.intro}
                </p>

                <p className="mt-5 text-[12px] font-extrabold uppercase tracking-[0.12em] text-navy/55" data-id="element-362" data-mp="7022bo31jety">
                  {volume.listTitle}
                </p>
                <ul className="mt-3 grid gap-2.5 sm:grid-cols-2 sm:gap-x-6" data-id="element-363" data-mp="27simpsirb04">
                  {volume.items.map(item => <li key={item} className="flex gap-2.5" data-id="element-364" data-mp="3ubbh6k4zj8d7">
                      <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-kidney" aria-hidden="true" data-id="element-365" data-mp="3peun79b3tzs7" />
                      <span className="text-[14px] leading-snug text-navy/85" data-id="element-366" data-mp="3ff3oswjfb0mu">
                        {item}
                      </span>
                    </li>)}
                </ul>

                <div className="mt-6 flex gap-3 rounded-2xl bg-white px-4 py-4" data-id="element-367" data-mp="1dosa5j71llt3">
                  <TargetIcon className="mt-0.5 h-4 w-4 shrink-0 text-kidney-dark" aria-hidden="true" data-id="element-368" data-mp="19mdq4vrn0g08" />
                  <div data-id="element-369" data-mp="2rifsxn2vq771">
                    <p className="text-[11px] font-extrabold uppercase tracking-[0.14em] text-navy/50" data-id="element-370" data-mp="2wjmwf9xzok7w">
                      L’obiettivo
                    </p>
                    <p className="mt-1 text-[14px] font-semibold leading-relaxed text-navy-deep sm:text-[15px]" data-id="element-371" data-mp="31b50i6vb70x3">
                      {volume.goal}
                    </p>
                  </div>
                </div>
              </div>
            </article>)}
        </div>

        <div className="mx-auto mt-9 max-w-md sm:mt-12" data-id="element-372" data-mp="2dlk5gplvsd7g">
          <CtaButton label="Voglio tutti e 6 i volumi" sub="6 volumi premium + 5 bonus • Download immediato" data-id="element-373" data-mp="2hmm4b5bvyn8w" />
        </div>
      </div>
    </section>;
}